import {
  action,
  background,
  border,
  chart,
  icon,
  overlay,
  text,
} from "../current/colors-figma";
import type { WebSemanticColors } from "./types";

type ColourSlot = (colors: WebSemanticColors) => string;

export const BRANCH_SEMANTIC_COLOURS = {
  "action/destructive/background": () => action.destructive.background,
  "action/destructive/icon": () => action.destructive.icon,
  "action/destructive/text": () => action.destructive.text,
  "action/inverse/background": () => action.inverse.background,
  "action/inverse/icon": () => action.inverse.icon,
  "action/neutral/background": () => action.neutral.background,
  "action/neutral/border": () => action.neutral.border,
  "action/neutral/icon": () => action.neutral.icon,
  "action/neutral/text": () => action.neutral.text,
  "action/primary/background": () => action.primary.background,
  "action/primary/icon": () => action.primary.icon,
  "action/primary/text": () => action.primary.text,
  "action/secondary/background": () => action.secondary.background,
  "action/secondary/background-subtle": () =>
    action.secondary["background-subtle"],
  "action/secondary/border": () => action.secondary.border,
  "action/secondary/icon": () => action.secondary.icon,
  "action/secondary/text": () => action.secondary.text,
  "background/card-header": () => background["card-header"],
  "background/tint": () => background.tint,
  "background/business": () => background.business,
  "background/disabled": () => background.disabled,
  "background/error": () => background.error,
  "background/gain": () => background.gain,
  "background/info": () => background.info,
  "background/inset": () => background.inset,
  "background/inverse": () => background.inverse,
  "background/isa": () => background.isa,
  "background/neutral": () => background.neutral,
  "background/page": () => background.page,
  "background/personal": () => background.personal,
  "background/raised": () => background.raised,
  "background/success": () => background.success,
  "background/warning": () => background.warning,
  "border/default": () => border.default,
  "border/disabled": () => border.disabled,
  "border/error": () => border.error,
  "border/focus": () => border.focus,
  "border/link": () => border.link,
  "border/selected": () => border.selected,
  "border/strong": () => border.strong,
  "border/subtle": () => border.subtle,
  "border/success": () => border.success,
  "border/warning": () => border.warning,
  "chart/data-1": () => chart["data-1"],
  "chart/data-2": () => chart["data-2"],
  "chart/data-3": () => chart["data-3"],
  "chart/data-4": () => chart["data-4"],
  "chart/data-5": () => chart["data-5"],
  "icon/brand": () => icon.brand,
  "icon/business": () => icon.business,
  "icon/disabled": () => icon.disabled,
  "icon/error": () => icon.error,
  "icon/gain": () => icon.gain,
  "icon/isa": () => icon.isa,
  "icon/link": () => icon.link,
  "icon/loss": () => icon.loss,
  "icon/personal": () => icon.personal,
  "icon/primary": () => icon.primary,
  "icon/primary-inverse": () => icon["primary-inverse"],
  "icon/secondary": () => icon.secondary,
  "icon/success": () => icon.success,
  "icon/warning": () => icon.warning,
  "overlay/overlay": () => overlay.overlay,
  "text/business": () => text.business,
  "text/disabled": () => text.disabled,
  "text/error": () => text.error,
  "text/gain": () => text.gain,
  "text/isa": () => text.isa,
  "text/link": () => text.link,
  "text/loss": () => text.loss,
  "text/personal": () => text.personal,
  "text/primary": () => text.primary,
  "text/primary-inverse": () => text["primary-inverse"],
  "text/secondary": () => text.secondary,
  "text/secondary-inverse": () => text["secondary-inverse"],
  "text/success": () => text.success,
  "text/tertiary": () => text.tertiary,
  "text/warning": () => text.warning,
} as const satisfies Record<string, ColourSlot>;

export type BranchSemanticColour = keyof typeof BRANCH_SEMANTIC_COLOURS;

export const branchColour = (
  _colors: WebSemanticColors,
  name: BranchSemanticColour
): string => BRANCH_SEMANTIC_COLOURS[name]();
